import type { Theme } from "@mui/material/styles";

/**
 * The `ai` palette (extracted / comment / review / validated tints) as the
 * active colour scheme renders it.
 *
 * Under a `cssVariables` theme, `theme.palette.ai` holds the frozen light
 * literals for the default scheme, while `theme.vars.palette.ai` holds the
 * custom-property references that follow the active scheme — so read `vars`
 * first, falling back to `palette` for themes that emit no variables. Extracted
 * so cell renderers resolve it in one call instead of repeating the branch
 * (which also keeps their complexity within budget).
 */
export const schemeAiPalette = (theme: Theme): Theme["palette"]["ai"] =>
  theme.vars?.palette.ai ?? theme.palette.ai;
